import { apiRequest } from "./httpClient";
import { router_basename } from "./Config";

// The two public ones. `token` is passed when it happens to exist and simply
// omitted when it doesn't - the backend treats a missing or invalid token as
// "guest" rather than as an error (see meetingController.identifyOptionalUser),
// which is what lets one code path serve both a signed-in member and a
// stranger who only has the link.
export async function getMeetingInfo(code, token) {
    return apiRequest("api/meetings/info", { token, body: { code } });
}

export async function joinMeeting(code, displayName, token) {
    return apiRequest("api/meetings/join", { token, body: { code, displayName } });
}

export async function createMeeting(token, { title, groupId, guestsAllowed } = {}) {
    return apiRequest("api/meetings/create", { token, body: { title, groupId, guestsAllowed } });
}

export async function endMeeting(token, code) {
    return apiRequest("api/meetings/end", { token, body: { code } });
}

export async function removeMeetingParticipant(token, code, identity) {
    return apiRequest("api/meetings/remove-participant", { token, body: { code, identity } });
}

export async function listMyMeetings(token) {
    return apiRequest("api/meetings/list-mine", { token, body: {} });
}

// The link that actually gets pasted into a chat. Built from the running
// page's own origin rather than a configured base URL, so one build produces a
// working link in dev (localhost:3000), in production, and from inside
// Electron - which loads a real https origin (see electron-starter.js's
// START_URL), not a file:// path.
export function meetingLink(code) {
    return `${window.location.origin}${router_basename}/meet/${code}`;
}

// Host-only. A meeting can contain people who never chose to be in a
// transcribed conversation, so unlike a group room (where anyone present can
// start the bot) only the host decides - and everyone in the room is told,
// over the bot's own data channel.
export async function startMeetingTranscript(token, code) {
    return apiRequest("api/meetings/transcript/start", { token, body: { code } });
}

export async function stopMeetingTranscript(token, code) {
    return apiRequest("api/meetings/transcript/stop", { token, body: { code } });
}

export async function listMeetingTranscripts(token, code) {
    return apiRequest("api/meetings/transcript/list", { token, body: { code } });
}
